export const TYPE_STUDENT = '1';
export const TYPE_PUBLIC = '2';
export const TYPE_TEACHER = '3';
